import { STATIC_LUCIDE_ICONS } from "./static-lucide-registry";

export type IconPrefix = "fas" | "fal" | "far" | "fab" | (string & {});
export type IconName = string;
export type IconProp = string | [string, string];

type LucideIconName = string;

const iconAliases: Record<string, LucideIconName> = {
  "check-circle": "circle-check",
  "times-circle": "circle-x",
  "question-circle": "circle-help",
  "info-circle": "info",
  "exclamation-circle": "circle-alert",
  "exclamation-triangle": "triangle-alert",
  "arrow-alt-left": "arrow-left",
  "arrow-alt-right": "arrow-right",
  "arrow-alt-up": "arrow-up",
  "arrow-alt-down": "arrow-down",
  "external-link-alt": "external-link",
  "external-link": "external-link",
  "share-square": "share-2",
  "sign-out-alt": "log-out",
  "sign-in-alt": "log-in",
  "plus-circle": "circle-plus",
  "minus-circle": "circle-minus",
  "check-square": "square-check",
  "square-check": "square-check",
  "circle-dot": "circle-dot",
  "dot-circle": "circle-dot",
  "circle-check": "circle-check",
  "circle-x": "circle-x",
  "circle-info": "info",
  "circle-help": "circle-help",
  "circle-plus": "circle-plus",
  "circle-minus": "circle-minus",
  "circle-pause": "circle-pause",
  "square-plus": "square-plus",
  "square-minus": "square-minus",
  "square-x": "square-x",
  "plus-square": "square-plus",
  "minus-square": "square-minus",
  "clock": "clock-3",
  "clock-alt": "clock-3",
  "clock-o": "clock-3",
  spinner: "loader-circle",
  "spinner-third": "loader-circle",
  "circle-notch": "loader-circle",
  "sync-alt": "refresh-cw",
  refresh: "refresh-cw",
  "refresh-circle": "refresh-cw",
  "chevron-left": "chevron-left",
  "chevron-right": "chevron-right",
  "chevron-up": "chevron-up",
  "chevron-down": "chevron-down",
  "arrow-left": "arrow-left",
  "arrow-right": "arrow-right",
  "arrow-up": "arrow-up",
  "arrow-down": "arrow-down",
  "arrow-up-right": "arrow-up-right",
  "arrow-down-right": "arrow-down-right",
  "arrow-down-left": "arrow-down-left",
  "arrow-left-right": "arrow-left-right",
  arrows: "arrow-left-right",
  expand: "maximize",
  compress: "minimize",
  "eye-slash": "eye-off",
  eye: "eye",
  filter: "filter",
  "filter-slash": "filter-x",
  search: "search",
  "search-plus": "zoom-in",
  "search-minus": "zoom-out",
  "cart-shopping": "shopping-cart",
  "shopping-cart": "shopping-cart",
  "shopping-bag": "shopping-bag",
  "moon-cloud": "cloud-moon",
  "sun-cloud": "cloud-sun",
  "cloud-moon": "cloud-moon",
  "cloud-sun": "cloud-sun",
  moon: "moon",
  sun: "sun",
  microsoft: "infinity",
  windows: "infinity",
  "comment-question": "message-circle-question",
  "message-circle-question": "message-circle-question",
  "comment-dollar": "circle-dollar-sign",
  "life-ring": "life-buoy",
  "life-buoy": "life-buoy",
  edit: "pencil",
  pen: "pencil",
  pencil: "pencil",
  "pencil-alt": "pencil",
  trash: "trash-2",
  "trash-alt": "trash-2",
  "trash-xmark": "trash-2",
  copy: "copy",
  clipboard: "clipboard",
  "clipboard-check": "clipboard-check",
  "clipboard-list": "clipboard-list",
  "clipboard-copy": "clipboard-copy",
  file: "file",
  "file-alt": "file-text",
  "file-text": "file-text",
  "file-pdf": "file-text",
  "file-word": "file-text",
  "file-excel": "file-spreadsheet",
  "file-powerpoint": "presentation",
  "file-code": "file-code",
  "file-image": "file-image",
  "file-video": "file-video",
  "file-audio": "file-audio",
  "file-archive": "file-archive",
  "file-upload": "upload",
  "file-download": "download",
  "file-plus": "file-plus",
  "file-minus": "file-minus",
  "file-check": "file-check",
  "file-question": "file-question",
  "file-search": "file-search",
  "file-invoice-dollar": "file-text",
  download: "download",
  upload: "upload",
  "cloud-upload": "cloud-upload",
  "cloud-upload-alt": "cloud-upload",
  "cloud-download": "cloud-download",
  cloud: "cloud",
  save: "save",
  "save-alt": "save",
  "paper-plane": "send",
  send: "send",
  reply: "reply",
  "reply-all": "reply-all",
  gift: "gift",
  gif: "image-play",
  trophy: "trophy",
  award: "award",
  medal: "medal",
  crown: "crown",
  rocket: "rocket",
  bell: "bell",
  "bell-slash": "bell-off",
  "bell-off": "bell-off",
  envelope: "mail",
  "envelope-open": "mail-open",
  mail: "mail",
  "mail-open": "mail-open",
  phone: "phone",
  "phone-slash": "phone-off",
  microphone: "mic",
  "microphone-slash": "mic-off",
  video: "video",
  "video-slash": "video-off",
  paperclip: "paperclip",
  image: "image",
  "image-portrait": "image",
  "image-polaroid": "image",
  "photo-film": "image",
  "photo-video": "image",
  link: "link",
  "link-slash": "link-2-off",
  globe: "globe",
  "globe-stand": "globe",
  language: "languages",
  languages: "languages",
  "map-marker-alt": "map-pin",
  "map-marker": "map-pin",
  "map-pin": "map-pin",
  building: "building-2",
  "house-building": "building-2",
  school: "school",
  "kit-medical": "stethoscope",
  seedling: "sprout",
  mobile: "smartphone",
  suitcase: "briefcase",
  briefcase: "briefcase",
  book: "book-open",
  "book-open": "book-open",
  books: "book-open-text",
  "graduation-cap": "graduation-cap",
  users: "users",
  user: "user",
  "user-plus": "user-round-plus",
  "user-minus": "user-round-minus",
  "user-slash": "user-round-x",
  "user-cog": "user-cog",
  "user-edit": "user-pen",
  "user-tie": "briefcase-business",
  "user-graduate": "graduation-cap",
  "user-secret": "user-round-cog",
  "user-ninja": "user-round-cog",
  "user-shield": "shield",
  "user-check": "user-check",
  "user-astronaut": "rocket",
  "user-friends": "users",
  "user-group": "users",
  "user-group-crown": "users",
  comment: "message-square",
  "comment-alt": "message-circle-more",
  "comment-dots": "message-circle-more",
  comments: "messages-square",
  message: "message-square",
  messages: "messages-square",
  "messages-square": "messages-square",
  chat: "message-square",
  inbox: "inbox",
  paper: "file",
  flag: "flag",
  "flag-checkered": "flag-triangle-right",
  list: "list",
  "list-ul": "list",
  "list-check": "list-checks",
  "list-alt": "list",
  grid: "layout-grid",
  "grid-3": "layout-grid",
  "grid-2": "layout-grid",
  "th-large": "layout-grid",
  th: "layout-grid",
  table: "table",
  columns: "columns-3",
  bars: "menu",
  "bars-staggered": "menu",
  "ellipsis-h": "ellipsis",
  "ellipsis-v": "ellipsis-vertical",
  "ellipsis-vertical": "ellipsis-vertical",
  "grip-vertical": "grip-vertical",
  "grip-horizontal": "grip-horizontal",
  "grip-dots-vertical": "grip-vertical",
  "grip-dots": "grip",
  plus: "plus",
  minus: "minus",
  question: "circle-help",
  warning: "triangle-alert",
  exclamation: "triangle-alert",
  archive: "archive",
  "search-square": "search",
  tag: "tag",
  tags: "tags",
  "thumbs-up": "thumbs-up",
  "thumbs-down": "thumbs-down",
  heart: "heart",
  star: "star",
  "star-half": "star-half",
  "star-half-alt": "star-half",
  sparkles: "sparkles",
  magic: "wand-sparkles",
  "wand-magic-sparkles": "wand-sparkles",
  bolt: "bolt",
  "bolt-slash": "bolt",
  lightbulb: "lightbulb",
  brain: "brain",
  "brain-circuit": "brain-circuit",
  cog: "settings",
  cogs: "settings-2",
  gear: "settings",
  "sliders-h": "sliders-horizontal",
  sliders: "sliders-horizontal",
  "filter-circle-xmark": "filter-x",
  bullseye: "target",
  target: "target",
  calendar: "calendar",
  "calendar-alt": "calendar-days",
  "calendar-day": "calendar-days",
  "calendar-check": "calendar-check",
  "calendar-times": "calendar-x",
  "calendar-plus": "calendar-plus",
  "calendar-range": "calendar-range",
  "calendar-circle-user": "calendar-days",
  "calendar-briefcase": "calendar",
  history: "history",
  "alarm-plus": "alarm-plus",
  house: "house",
  home: "house",
  wallet: "wallet",
  coins: "circle-dollar-sign",
  coin: "circle-dollar-sign",
  "money-bill": "banknote",
  "money-bill-alt": "banknote",
  "money-bill-wave": "banknote",
  "credit-card": "credit-card",
  "chart-bar": "chart-column",
  "chart-line": "chart-line",
  "chart-radar": "radar",
  "chart-gantt": "chart-gantt",
  "chart-pie": "pie-chart",
  "circle-alert": "circle-alert",
  "circle-question": "circle-help",
  "circle-user": "circle-user",
  "circle-key": "key-round",
  "circle-ellipsis": "ellipsis",
  shapes: "shapes",
  layers: "layers-3",
  "layer-group": "layers-3",
  sitemap: "network",
  "project-diagram": "network",
  road: "route",
  route: "route",
  share: "share-2",
  code: "code-2",
  "code-branch": "git-branch",
  codepen: "code",
  "file-contract": "scroll-text",
  ticket: "ticket",
  "ticket-simple": "ticket",
  "file-csv": "file-spreadsheet",
  "file-spreadsheet": "file-spreadsheet",
  poll: "bar-chart-3",
  keyboard: "keyboard",
  stop: "square",
  square: "square",
  circle: "circle",
  "square-js": "square-code",
  "arrow-right-left": "arrow-left-right",
  "arrow-up-right-from-square": "external-link",
  "arrow-right-from-line": "arrow-right",
  "arrow-left-from-line": "arrow-left",
  "phone-volume": "phone",
  speech: "message-square",
  "user-pen": "user-pen",
  "file-pen": "file-pen",
  "image-up": "image-up",
  "image-down": "image-down",
  "building-columns": "building-2",
  "badge-check": "badge-check",
  "badge-info": "badge-info",
  "badge-question": "badge-help",
  "badge-alert": "badge-alert",
  "badge-pen": "square-pen",
  "cloud-download-alt": "cloud-download",
  "file-paste": "clipboard-paste",
  "bell-exclamation": "bell-ring",
  slash: "slash",
  times: "x",
  close: "x",
  xmark: "x",
  "xmark-circle": "circle-x",
  "xmark-square": "square-x",
  "rectangle-history-circle-plus": "square-plus",
  "circle-history": "history",
  "circle-user-round": "circle-user-round",
  "globe-americas": "globe",
  laptop: "laptop",
  lock: "lock",
  unlock: "unlock",
  "briefcase-business": "briefcase-business",
  "briefcase-medical": "stethoscope",
  bookmark: "bookmark",
  map: "map",
  "message-circle-more": "message-circle-more",
  "message-square-more": "message-square-more",
  "message-square-text": "message-square-text",
  album: "image",
  "lightbulb-on": "lightbulb",
  "grid-2x2": "layout-grid",
  "layout-grid": "layout-grid",
  "layout-list": "layout-list",
  "columns-3": "columns-3",
  "calendar-x": "calendar-x",
  "calendar-user": "calendar-days",
  "arrow-down-up": "arrow-up-down",
  "log-out": "log-out",
  "log-in": "log-in",
  "alert-triangle": "triangle-alert",
  "alert-circle": "circle-alert",
  server: "server",
  database: "database",
  "file-bar-chart": "file-bar-chart",
  "file-chart-column": "file-bar-chart",
  "square-parking": "square",
  "pen-clip": "pen-line",
  "file-pen-line": "file-pen-line",
  "square-pen": "square-pen",
  "square-arrow-out-up-right": "external-link",
  "inbox-in": "inbox",
  "arrow-right-circle": "arrow-right",
  "arrow-left-circle": "arrow-left",
  "arrow-up-circle": "arrow-up",
  "arrow-down-circle": "arrow-down"
};

const defaultIcon: LucideIconName = "circle";

function isKnownLucideIcon(name: string) {
  return name in STATIC_LUCIDE_ICONS;
}

/** Lucide names used by faToLucideName / resolveIconName. */
export function getPrefetchLucideIconNames(): string[] {
  return Object.keys(STATIC_LUCIDE_ICONS);
}

function toKebabCase(value: string) {
  return value
    .replace(/^fa/, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[_\s]+/g, "-")
    .replace(/-{2,}/g, "-")
    .toLowerCase();
}

export function faToLucideName(icon: string): LucideIconName {
  const normalized = toKebabCase(icon);
  const aliased = iconAliases[normalized];
  if (aliased && isKnownLucideIcon(aliased)) return aliased;
  if (isKnownLucideIcon(normalized)) return normalized;

  const stripped = normalized.replace(/^fa-/, "");
  if (isKnownLucideIcon(stripped)) return stripped;

  return defaultIcon;
}

export function resolveIconName(icon: IconProp | string | undefined): LucideIconName {
  if (!icon) return defaultIcon;

  if (Array.isArray(icon)) {
    return faToLucideName(icon[1]);
  }

  return faToLucideName(icon);
}

const namedSizes: Record<string, number> = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 20,
  xl: 24,
  "1x": 16,
  "2x": 24,
  "3x": 32,
  "4x": 40,
  "5x": 48
};

export function sizeToPixels(size?: string | number) {
  if (typeof size === "number") return size;
  if (!size) return 18;

  if (namedSizes[size] !== undefined) return namedSizes[size];

  const numeric = Number(size.replace(/x$/, ""));
  if (Number.isNaN(numeric)) return 18;

  return numeric * 16;
}
